import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import type { EcoBoxServices, SessionEngine } from '@ecobox/firebase';
import { ToastProvider } from '@ecobox/ui';
import { Layout, RequireStaff } from './Layout';
import { HandoverPage } from './pages/Handover';
import { HandoverSessionPage } from './pages/HandoverSession';
import { LoadPage } from './pages/Load';
import { LoginPage } from './pages/Login';
import { MePage } from './pages/Me';
import { RaiseExceptionPage } from './pages/RaiseException';
import { ReceivePage } from './pages/Receive';
import { ScanPage } from './pages/Scan';
import { SessionPage } from './pages/Session';
import { TodayPage } from './pages/Today';
import { TrainingPage } from './pages/Training';
import { EndRunPage } from './pages/driver/EndRunPage';
import { RunLoadPage } from './pages/driver/RunLoadPage';
import { RunPage } from './pages/driver/RunPage';
import { StopPage } from './pages/driver/StopPage';
import { YardPage } from './pages/Yard';
import { ServicesProvider } from './services';
import { SessionsProvider } from './sessions';

export function App({ services, engine }: { services: EcoBoxServices; engine: SessionEngine }) {
  useEffect(() => {
    // Starts once per page load and runs for its lifetime.
    void services.start();
  }, [services]);

  return (
    <ServicesProvider services={services}>
      <SessionsProvider engine={engine}>
        <ToastProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route element={<RequireStaff />}>
                <Route element={<Layout />}>
                  <Route index element={<Navigate to="/today" replace />} />
                  <Route path="/today" element={<TodayPage />} />
                  <Route path="/load" element={<LoadPage />} />
                  <Route path="/receive" element={<ReceivePage />} />
                  <Route path="/session/:id" element={<SessionPage />} />
                  <Route path="/handover" element={<HandoverPage />} />
                  <Route path="/handover/:id" element={<HandoverSessionPage />} />
                  <Route path="/run/:runId" element={<RunPage />} />
                  <Route path="/run/:runId/load" element={<RunLoadPage />} />
                  <Route path="/run/:runId/end" element={<EndRunPage />} />
                  <Route path="/run/:runId/stop/:stopId" element={<StopPage />} />
                  <Route path="/yard" element={<YardPage />} />
                  <Route path="/exception" element={<RaiseExceptionPage />} />
                  <Route path="/scan" element={<ScanPage />} />
                  <Route path="/me" element={<MePage />} />
                  <Route path="/training" element={<TrainingPage />} />
                  <Route path="*" element={<Navigate to="/today" replace />} />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
        </ToastProvider>
      </SessionsProvider>
    </ServicesProvider>
  );
}
